import {CPSConstants} from "commonUtils/enumerations";

export const CPSErrorBoundaryFallbackStyle = {
  boxBackgroudStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minHeight: CPSConstants.BGHEIGHT,
    display: "flex",
    alignItems: "center",
    backgroundSize: "cover",
    justifyContent: "center",
    backgroundColor: CPSConstants.STANDARDCOLOR,
    backgroundPosition: "center",
  },
  errorHandlerBoxStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#fcc",
    color: "#900",
    borderTop: "0.3rem solid",
    borderBottom: "0.3rem solid",
    padding: "0.625rem 0.625rem 0.625rem 2.875rem",
    minWidth: "50rem",
    fontWeight: CPSConstants.FONTWEIGHT,
  },
  errorOutlineIconStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    color: "#900",
  },
  workWrapErrorTextStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    wordWrap: "break-word",
  },
  clickHereStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
  },
};
